//
export const calculateMaxDays = (maxSiloCapacity: number, dailyConsumptionRate: number) => {
  const totalCapacity = maxSiloCapacity / dailyConsumptionRate;
  return totalCapacity;
};

export const increasedDays = (days: number, dailyConsumptionRate: number, bufferValue: number, maxSiloCapacity: number) => {
  const bufferInKg = maxSiloCapacity * (bufferValue / 100);
  return days * dailyConsumptionRate + bufferInKg;
};

export const calculateZIndexValues = (bufferValue: number, maxDays: number, days: number): { buffer: number; days: number } => {
  const newBuffer = bufferValue / maxDays;
  const newDay = (days / maxDays) * 10;

  if (newBuffer > newDay) {
    return { days: 50, buffer: 100 };
  } else {
    return { buffer: 100, days: 50 };
  }
};
export const bufferKgValue = (maxSiloCapacity: number, bufferValue: number, convertion: boolean = false) => {
  return convertion ? maxSiloCapacity * (bufferValue / 100) : maxSiloCapacity * bufferValue;
};
